import getConfig from 'next/config'

/** @type {import('./index').Config} */
export function getPublicRuntimeConfig() {
  return getConfig().publicRuntimeConfig
}
